module.exports = __webpack_public_path__ + "img/Platine_0000_1.94244e3f.png";